import integrated from '../../components/integrated/integrated'
import institutional from '../../components/institutional/institutional'
import responsibilityLanding from '../../components/responsibilityLanding/responsibilityLanding'
import contingency from '../../components/contingency/contingency'
import characteristicDisplay from '../../components/characteristicDisplay/characteristicDisplay'
export default ({
    data() {
        return {
            currentMenu: '/security/integrated',
        }
    },
    components: { integrated, institutional, responsibilityLanding, contingency, characteristicDisplay },
    created() {
        var route = this.$route.path
        this.currentMenu = route
    },
    watch:{
        //监听路由变化
        $route(to,from){
            var route = to.path
            this.currentMenu = route
        }
    },
    methods: {
        selectMenu(page){
            var route = this.$route.path
            this.currentMenu = page
            if(page != route){
                this.$router.push(page)
            }
        }
    }
})


// WEBPACK FOOTER //
// ./src/pages/security/security.vue.js